import { replaceHtmlExtensionWithSlash } from './strings';

const LANGUAGE_INDEX_DIFF = 2;

export const getLanguageRootFromPath = (url: string) => {
  const paths = replaceHtmlExtensionWithSlash(url).split('/');

  return paths[paths.length - LANGUAGE_INDEX_DIFF];
};
